module.exports = __webpack_public_path__ + "static/media/A-flat-Triads.fd90d606.png";